module.exports = {
  api: {
    base: 'https://hfs-wechat-be.yunxiao.com',
    idsp: 'https://open.yunxiao.com/tpgw/auth',
    timeout: 20000
  },
  baseRoute: '/official/',
  // appId: 'wxa16ab844bcc07624',
  appId: 'wx03bbc392f0b75e2c',
  baseUrl: 'https://hfs-wechat.yunxiao.com/official',
  cookie: 'hfs-wechat-be-session-id',
  download: 'https://hfs-wechat.yunxiao.com/official/download',
  cross: {
    yltPage: 'https://m2.yunxiao.com/v2/collegeRecommend.html' // 育路通院校推荐h5页
  }
}



// WEBPACK FOOTER //
// ./src/feConfig/production.js